<template>
    <v-container fluid>
        <frame :card="card"></frame>
    </v-container>
</template>

<script>
import Frame from '../components/card/Frame';
import API from '../services/Api';
import parser from '../utils/parser';
export default {
    data: ()=>({
        card: []
    }),
    components:{
        'frame': Frame
    },
    beforeCreate(){
        var id = this.$route.params.id;
        var token = this.$store.state.auth.token;
        API.getCard(token, id)
            .then(response => {
                this.card = parser.getCardToCard(response);
                this.card.medias.forEach((m)=>{                    
                    m.src =  API.getBaseUrl()+"imagens/" + m.name;
                });
                this.card.questions.forEach((question)=>{
                    if(question.media !== null){
                        question.media.src = API.getBaseUrl()+"imagens/" + question.media.name
                    }
                });
            })                
            .catch(err=>{
                console.log(err);
            })
    }
}
</script>